<template>
  <div class="floatBar">
    <ul>
      <li>
        <router-link :to="'/order/confirm/' + id + '/' + month + '?s=official'">
          <i class="icon-shopping"></i>
          <span>立即购买</span>
        </router-link>
      </li>
      <!-- <li v-on:mouseenter="wechatActive = true" v-on:mouseleave="wechatActive = false">
        <a href="##">
          <i class="icon-wx"></i>
          <span>微信咨询</span>
        </a>
        <div class="wxCode" v-show="wechatActive">
          <img :src="codeUrl" alt width="120px" />
        </div>
      </li> -->
      <li v-if="id != 197">
        <a href="#" @click="download">
          <i class="icon-download"></i>
          <span>下载软件</span>
        </a>
      </li>
      <li v-on:mouseenter="telActive = true" v-on:mouseleave="telActive = false">
        <a href="##">
          <i class="icon-tel"></i>
          <span>服务热线</span>
        </a>
        <div class="tel" v-show="telActive">021-20219999</div>
      </li>
      <li>
        <a @click="goTop($event)">
          <i class="icon-top"></i>
          <span>回顶部</span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ["id", "month", "downloadUrl"],
  data() {
    return {
      codeUrl: require("@/assets/images/common/code.jpg"),
      wechatActive: false,
      telActive: false
    };
  },
  methods: {
    toQQCounsel() {
      //qq咨询
      window.open(
        "http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDA2MTUxOV8yMTY2MzZfODAwMDYxNTE5XzJf",
        "_blank",
        "height=402, width=644, toolbar=no, scrollbars=no, menubar=no, status=no"
      );
    },
    goTop() {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
    download() {
      this.$get("/product/query?id=" + this.id)
        .then(response => {
          if (response.code === 0) {
            window.location.href = response.data.downloadUrl;
          } else {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    }
  }
};
</script>

<style scope>
.floatBar {
  position: fixed;
  right: 0;
  top: 190px;
  z-index: 3;
}

.floatBar ul li {
  width: 68px;
  height: 66px;
  box-sizing: border-box;
  border: 1px solid #959595;
  border-radius: 10px;
  background: #fff;
  margin-bottom: 2px;
  box-shadow: 2px 1px 4px rgba(0, 53, 199, 0.1);
  font-size: 22px;
  color: #166eff;
  text-align: center;
  cursor: pointer;
  position: relative;
}
.floatBar ul li a {
  display: block;
  color: #166eff;
}

.floatBar ul li:hover {
  background: #166eff;
}

.floatBar ul li:hover a {
  color: #fff;
}

.floatBar .wxCode {
  position: absolute;
  left: -132px;
  bottom: 0;
  padding: 2px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #166eff;
  border-radius: 8px;
  width: 130px;
  height: 130px;
  box-shadow: 2px 1px 4px rgba(61, 91, 173, 0.15);
}

.floatBar .wxCode img {
  width: 100%;
}

.floatBar .tel {
  position: absolute;
  left: -133px;
  top: 0px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #166eff;
  border-radius: 8px;
  width: 131px;
  height: 66px;
  font-size: 16px;
  color: #000;
  line-height: 66px;
  text-align: center;
  box-shadow: 2px 1px 4px rgba(0, 53, 199, 0.15);
}
.floatBar ul li span {
  display: block;
  font-size: 13px;
}
.floatBar ul li .icon-shopping {
  background-image: url("~@/assets/images/icon/shopping.png");
  width: 27px;
  height: 32px;
  margin: 3px auto 6px;
}
.floatBar ul li .icon-wx {
  background-image: url("~@/assets/images/icon/wx.png");
  width: 31px;
  height: 25px;
  margin: 7px auto 6px;
}
.floatBar ul li .icon-qq {
  background-image: url("~@/assets/images/icon/qq.png");
  width: 25px;
  height: 27px;
  margin: 8px auto 6px;
}
.floatBar ul li .icon-download {
  background-image: url("~@/assets/images/icon/download.png");
  width: 35px;
  height: 23px;
  margin: 8px auto 6px;
}
.floatBar ul li .icon-tel {
  background-image: url("~@/assets/images/icon/tel.png");
  width: 31px;
  height: 26px;
  margin: 8px auto 5px;
}
.floatBar ul li .icon-top {
  background-image: url(~@/assets/images/icon/top.png);
  width: 25px;
  height: 29px;
  margin: 7px auto 4px;
}
.floatBar ul li:hover .icon-shopping {
  background-image: url("~@/assets/images/icon/shopping-h.png");
}
.floatBar ul li:hover .icon-wx {
  background-image: url("~@/assets/images/icon/wx-h.png");
}
.floatBar ul li:hover .icon-qq {
  background-image: url("~@/assets/images/icon/qq-h.png");
}
.floatBar ul li:hover .icon-download {
  background-image: url("~@/assets/images/icon/download-h.png");
}
.floatBar ul li:hover .icon-tel {
  background-image: url("~@/assets/images/icon/tel-h.png");
}
.floatBar ul li:hover .icon-top {
  background-image: url("~@/assets/images/icon/top-h.png");
}
.floatBar ul li:nth-child(1) span{color: #c52e1a;}
.floatBar ul li:nth-child(1):hover span{color: #fff;}
</style>


// WEBPACK FOOTER //
// src/components/product/FloatBar.vue